<div *ngFor="let team of allTeams">
    <p-checkbox name="teams" [value]="team"
        [(ngModel)]="entity.properties.teams"></p-checkbox>
    <label>&nbsp;{{team.name}}</label>
</div>